import { Box, LinearProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { styles } from "../SignupScreen/styles";
import { styles as styles1 } from "./styles";
import * as qs from "qs";
import {
  HTTP,
  PRIVACY_POLICY_LINK,
  TERMS_SERVICE_LINK,
  authEndpoints,
} from "../../utils/constants/httpConstants";
import EventEmitter from "../../utils/emitter/EventEmitter";
import { EMITTER_ERROR } from "../../utils/constants";
import {
  INVALID_PAGE_PATH, PLAN_PATH,

} from "../../utils/constants/routes";
import { saveSignupState, loadSignupState } from "../../utils/helpers/signupState";
import { Anchor, FullScreenLoader, RightsTag } from "../../components";
import { LOGIN_REACHIQ_LOGO } from "../../utils/constants/assets";

import { useDispatch } from "react-redux";
import { decryptEmail, encryptEmail } from "../../utils/helpers";
import Image from "../../image/Image";
import { Strings } from "./strings";
import { GREY } from "../../utils/constants/colors";
import { fontWeight } from "../../utils/constants/UI";
import Typography from "../../components/Typography/Typography";
import Button from "../../components/Buttons/Button";
import { POST } from "../../Apis/apiWrapper";
import RadioButtons from "../../components/RadioButton/RadioButtons";

const GoogleRedirectScreen = () => {
  const classes = styles();
  const classes1 = styles1();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const parsedObject = qs.parse(location.search?.slice(1));
  const [isApiCalled, setIsApiCalled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [tenantAccounts, setTenantAccounts] = useState([]);
  const [selectedTenant, setSelectedTenant] = useState("");
  const [token, setToken] = useState("");
  const [navigating, setNavigating] = useState(false);

  useEffect(() => {
    if (!isApiCalled) {
      (async () => {
        try {
          let endPoint = authEndpoints.googleTokenVerify;
          const token = sessionStorage.getItem(Strings.INVITATION_TOKEN);
          const payload = { code: parsedObject?.code, token: token || "", esp: 2 };
          const encrypedHost = localStorage.getItem(Strings.host);
          let decryptedHost = "";
          if (encrypedHost?.length) {
            decryptedHost = decryptEmail(encrypedHost || "");
          }
          if (encrypedHost?.length) {
            payload.tenant_url = decryptedHost;
            endPoint = authEndpoints.googleLogin;
          }
          localStorage.clear();

          setIsApiCalled(true);

          if (payload?.code?.length) {
            const response = await POST(endPoint, payload);
            if (response?.status === 251) {
              setTenantAccounts(response?.data?.data?.tenants);
              setToken(response?.data?.data?.token);
              setSelectedTenant(response?.data?.data?.tenants?.[0]?._id);
            } else if (response?.status === 252) {
              // New-tenant OAuth signup (2026-07-03): the BE seeded a signup draft. Enter the SAME
              // paid flow as email signup — carry the verified name/email + draft_id into the plan
              // screen. No legacy instant-tenant screen; free plan stays hard-blocked downstream.
              const d = response?.data?.data || {};
              const signupState = {
                firstName: d.first_name || "",
                lastName:  d.last_name || "",
                email:     d.owner_email || "",
                draft_id:  d.draft_id,
                oauth:     true,
                provider:  d.provider || "google",
              };
              // Merge — keep preselected_plan/billing captured before the OAuth round-trip.
              saveSignupState({ ...loadSignupState(), ...signupState });
              navigate(PLAN_PATH, { state: signupState });
            } else if (response?.status === 253) {
              const rawData = JSON.parse(JSON.stringify(response?.data?.data));
              delete rawData?.tenant_url;
              const data = JSON.stringify(rawData);
              const encryptedData = encryptEmail(data);
              const registrationURL = response?.data?.data?.tenant_url + +'/' + authEndpoints.googleAuthTokenWithoutPrefix + encryptedData;
              let anchor = document.createElement("a");
              // Fix #7: removed console.logs that leaked the auth redirect URL + encrypted payload.
              anchor.href = HTTP + response?.data?.data?.tenant_url?.toString() + "/" + authEndpoints.googleAuthTokenWithoutPrefix?.toString() + encryptedData?.toString();

              anchor.click();
            } else {
              const URL = response?.data?.data?.tenant_url;
              let anchor = document.createElement("a");
              anchor.href = HTTP + URL;
              anchor.click();
            }
          } else {
            const URL = HTTP + decryptedHost;
            let anchor = document.createElement("a");
            anchor.href = URL;
            anchor.click();
          }
        } catch (error) {
          console.log("error", error);
          EventEmitter.emit(
            EMITTER_ERROR,
            error?.data?.message || Strings.ERROR
          );
          navigate(INVALID_PAGE_PATH)
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [navigate, parsedObject, isApiCalled, dispatch]);

  const handleMultiTenantContinue = async () => {
    try {
      const payload = {
        tenant_id: selectedTenant,
        token: token,
      };
      setNavigating(true);
      const response = await POST(authEndpoints.loginForTenant, payload);
      const URL = response?.data?.data?.tenant_url;
      let anchor = document.createElement("a");
      anchor.href = HTTP + URL;
      anchor.click();
    } catch (error) {
      EventEmitter.emit(EMITTER_ERROR.at, error?.response?.data?.message);
    }
    setNavigating(false);
  };
  const radioButtonDashboardData = [

    { id: selectedTenant, label: "" },

  ];

  return (
    <Box className={classes1.container1}>
      {
        loading || tenantAccounts?.length === 0 ? (
          <FullScreenLoader />
        ) : (
          // This Box is for multiple tenants 
          <Box className={classes.container}>
            <Box className={classes.leftContainer}>
              <Box>
                <div className={classes.containLogo}>
                  <Image src={LOGIN_REACHIQ_LOGO} className={classes.logo} />
                </div>
              </Box>
              {/* Main auth form here */}
              <Box component="div" className={classes1.headers}>
                <Box className={classes1.containTexts}>
                  <Typography
                    label={Strings.YOUR_ACCOUNTS}
                    color={GREY.PRIMARY}
                    size={"dxs"}
                    fontWeight={fontWeight.SEMIBOLD}
                  />
                  <Typography
                    label={Strings.CHOOSE_ONE_TENANT}
                    color={GREY.TERTIARY}
                    size={"sm"}
                    fontWeight={fontWeight.REGULAR}
                  />
                </Box>

                <Box sx={{ width: "100%" }}>
                  {tenantAccounts?.map((tenant) => {
                    return (
                      <Box
                        className={
                          selectedTenant === tenant?._id
                            ? classes1.borderRed
                            : classes1.borderGrey
                        }
                        onClick={(e) => setSelectedTenant(tenant?._id)}
                      >


                        <RadioButtons
                          value={tenant?._id}
                          onChange={(e) => setSelectedTenant(tenant?._id)}
                          items={radioButtonDashboardData}
                        />
                        <Typography
                          label={tenant?.tenant_url}
                          color={GREY.TERTIARY}
                          size={"sm"}
                          fontWeight={fontWeight.REGULAR}
                        />
                      </Box>
                    );
                  })}
                </Box>
                <Box className={classes1.containBtns}>

                  {/* <button className={classes1.cancelBtn}>Cancel</button> */}
                  {navigating ? (
                    <Box className={classes.LINEAR}>
                      <LinearProgress />
                    </Box>
                  ) : (
                    <Button
                      size={"sm36"}
                      variant={"primary"}
                      label={Strings.CONTINUE_WITH_ACC}
                      onClick={handleMultiTenantContinue}
                    />
                  )}
                </Box>
              </Box>
              {/* Main auth form here */}
            </Box>
          </Box>
        )
        // This is for multiple tenants
      }
      <div className={classes.containPolicy}>
        <RightsTag className={classes.termsPara} />
        {/* Privacy and Terms. */}
        <Anchor
          href={PRIVACY_POLICY_LINK}
          className={classes.privacyLink}
          target="_blank"
        >
          <Typography
            size={"xs"}
            color={GREY.SECONDARY}
            fontWeight={fontWeight.SEMIBOLD}
            label={Strings.PRIVACY}
          />
        </Anchor>
        <div className={classes.TypoHead}>
          <Typography
            size={"xs"}
            color={GREY.TERTIARY}
            fontWeight={fontWeight.REGULAR}
            label={Strings.AND}
          />{" "}
        </div>
        <Anchor
          href={TERMS_SERVICE_LINK}
          className={classes.privacyLink}
          target="_blank"
        >
          <Typography
            size={"xs"}
            color={GREY.SECONDARY}
            fontWeight={fontWeight.SEMIBOLD}
            label={Strings.TERMS}
          />
        </Anchor>
      </div>
    </Box>
  );
};

export default GoogleRedirectScreen;
